export let hres7feColumns = () => {
  let indexColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '80',
    style: 'min-width: 120px;',
    class: 'align-center'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '90',
    style: 'min-width: 180px;'
  }, {
    key: 'desc_flgappr',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '100',
    style: 'min-width: 120px;'
  }, {
    key: 'dteapman',
    name: '',
    labelCodapp: 'HRES7FEC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres7fe.js